import type { AttendanceRecord } from '@/mocks/db/schema';
export type EmployeeAttendanceBookSummary = {
  /** 表示用: 実勤務に該当する日数 */
  workingDayNumerator: number;
  /** 表示用: 当月の平日数（概算スケジュール日数） */
  workingDayDenominator: number;
  absentDays: number;
  paidLeaveDays: number;
  totalWorkMinutes: number;
  totalOvertimeMinutes: number;
  lateCount: number;
  earlyLeaveCount: number;
  /** 勤務地名に「リモート」を含む日 */
  remoteDays: number;
};
function countWeekdaysInMonth(year: number, month: number): number {
  const daysInMonth = new Date(year, month, 0).getDate();
  let count = 0;
  for (let d = 1; d <= daysInMonth; d++) {
    const wd = new Date(year, month - 1, d).getDay();
    if (wd !== 0 && wd !== 6) count++;
  }
  return count;
}
function timeToMinutes(time: string): number {
  const [h, m] = time.split(':').map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
}
function recordWorkingMinutes(record: AttendanceRecord): number {
  if (record.actualStart === null || record.actualEnd === null) return 0;
  return Math.max(0, timeToMinutes(record.actualEnd) - timeToMinutes(record.actualStart));
}
const WORKED_STATUSES = new Set<AttendanceRecord['status']>(['present', 'late', 'early_leave']);
export function computeEmployeeAttendanceBookSummary(records: AttendanceRecord[], year: number, month: number): EmployeeAttendanceBookSummary {
  const denominator = countWeekdaysInMonth(year, month);
  let workingDayNumerator = 0;
  let absentDays = 0;
  let paidLeaveDays = 0;
  let totalWorkMinutes = 0;
  let totalOvertimeMinutes = 0;
  let lateCount = 0;
  let earlyLeaveCount = 0;
  let remoteDays = 0;
  for (const r of records) {
    if (WORKED_STATUSES.has(r.status)) {
      workingDayNumerator++;
    }
    if (r.status === 'absent') absentDays++;
    if (r.status === 'paid_leave') paidLeaveDays++;
    totalWorkMinutes += recordWorkingMinutes(r);
    totalOvertimeMinutes += r.overtimeMinutes;
    if (r.status === 'late') lateCount++;
    if (r.status === 'early_leave') earlyLeaveCount++;
    if (r.workplaceName.includes('リモート')) remoteDays++;
  }
  return {
    workingDayNumerator,
    workingDayDenominator: denominator,
    absentDays,
    paidLeaveDays,
    totalWorkMinutes,
    totalOvertimeMinutes,
    lateCount,
    earlyLeaveCount,
    remoteDays
  };
}